import { Outlet } from 'react-router-dom'

import { DisplayFontsLoader } from '@/components/shared/DisplayFontsLoader'

/** Mirrors layouts/AudiencesRouteLayout/AudiencesRouteLayout.tsx */
export function SpaAudiencesLayout() {
  return (
    <>
      <DisplayFontsLoader />
      <Outlet />
    </>
  )
}
